module.exports = __webpack_public_path__ + "img/lwg.360b116d.png";